import GalleryIcon from '@/assets/icons/file-ls-gallery.svg?react'
import ListIcon from '@/assets/icons/file-ls-list.svg?react'

export type ViewMode = 'list' | 'gallery'

interface ViewToggleProps {
  value: ViewMode
  onChange: (mode: ViewMode) => void
}

export function ViewToggle({ value, onChange }: ViewToggleProps) {
  return (
    <div className="flex items-start rounded-xl bg-panel-gray-100 p-1">
      <button
        className={`rounded-lg px-4 py-2 ${value === 'list' ? 'bg-highlight/10' : ''}`}
        onClick={() => onChange('list')}
      >
        <ListIcon className={`h-5 w-5 ${value === 'list' ? 'text-highlight' : 'text-primary'}`} />
      </button>
      <button
        className={`rounded-lg px-4 py-2 ${value === 'gallery' ? 'bg-highlight/10' : ''}`}
        onClick={() => onChange('gallery')}
      >
        <GalleryIcon
          className={`h-5 w-5 ${value === 'gallery' ? 'text-highlight' : 'text-primary'}`}
        />
      </button>
    </div>
  )
}
